import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneAppleAuth");
  return hybrid;
}
async function signIn() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _raw_state, _raw_identityToken, _raw_authorizationCode, _raw_email, _raw_fullName_namePrefix, _raw_fullName_givenName, _raw_fullName_middleName, _raw_fullName_familyName, _raw_fullName_nameSuffix, _raw_fullName_nickname;
  var result = await native().signIn({
    requestedScopes: options.requestedScopes,
    nonce: options.nonce,
    state: options.state
  }).catch(rethrowNativeError);
  if (result.type === "cancel") return {
    type: "cancel"
  };
  var raw = result.credential;
  if (!raw) throw new Error("Auth.Apple.signIn: success without a credential");
  return {
    type: "success",
    credential: {
      user: raw.user,
      state: (_raw_state = raw.state) !== null && _raw_state !== void 0 ? _raw_state : null,
      identityToken: (_raw_identityToken = raw.identityToken) !== null && _raw_identityToken !== void 0 ? _raw_identityToken : null,
      authorizationCode: (_raw_authorizationCode = raw.authorizationCode) !== null && _raw_authorizationCode !== void 0 ? _raw_authorizationCode : null,
      email: (_raw_email = raw.email) !== null && _raw_email !== void 0 ? _raw_email : null,
      fullName: raw.fullName ? {
        namePrefix: (_raw_fullName_namePrefix = raw.fullName.namePrefix) !== null && _raw_fullName_namePrefix !== void 0 ? _raw_fullName_namePrefix : null,
        givenName: (_raw_fullName_givenName = raw.fullName.givenName) !== null && _raw_fullName_givenName !== void 0 ? _raw_fullName_givenName : null,
        middleName: (_raw_fullName_middleName = raw.fullName.middleName) !== null && _raw_fullName_middleName !== void 0 ? _raw_fullName_middleName : null,
        familyName: (_raw_fullName_familyName = raw.fullName.familyName) !== null && _raw_fullName_familyName !== void 0 ? _raw_fullName_familyName : null,
        nameSuffix: (_raw_fullName_nameSuffix = raw.fullName.nameSuffix) !== null && _raw_fullName_nameSuffix !== void 0 ? _raw_fullName_nameSuffix : null,
        nickname: (_raw_fullName_nickname = raw.fullName.nickname) !== null && _raw_fullName_nickname !== void 0 ? _raw_fullName_nickname : null
      } : null,
      realUserStatus: raw.realUserStatus
    }
  };
}
var Apple = Object.freeze({
  get isAvailable() {
    return native().isAvailable();
  },
  signIn,
  getCredentialState: function getCredentialState(user) {
    return native().getCredentialState(user).catch(rethrowNativeError);
  }
});
var Auth = Object.freeze({
  Apple
});
export {
  Auth
};
//# sourceMappingURL=index.native.js.map
